"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var style_1 = require("@lyearn/style");
function SvgEyeClose(_props, svgRef) {
    var props = (0, style_1.useSvg)(_props);
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "0 0 24 24", ref: svgRef }, props),
        React.createElement("g", { "data-name": "Layer 2" },
            React.createElement("g", { "data-name": "eye-off" },
                React.createElement("path", { d: "M4.71 3.29a1 1 0 00-1.42 1.42l5.63 5.63a3.5 3.5 0 004.74 4.74l5.63 5.63a1 1 0 001.42 0 1 1 0 000-1.42zM12 13.5a1.5 1.5 0 01-1.5-1.5v-.07l1.56 1.56z" }),
                React.createElement("path", { d: "M12.22 17c-4.3.1-7.12-3.59-8-5a13.7 13.7 0 012.24-2.72L5 7.87a15.89 15.89 0 00-2.87 3.63 1 1 0 000 1c.63 1.09 4 6.5 9.89 6.5h.25a9.48 9.48 0 003.23-.67l-1.58-1.58a7.74 7.74 0 01-1.7.25zM21.87 11.5c-.64-1.11-4.17-6.68-10.14-6.5a9.48 9.48 0 00-3.23.67l1.58 1.58a7.74 7.74 0 011.7-.25c4.29-.11 7.11 3.59 8 5a13.7 13.7 0 01-2.29 2.72L19 16.13a15.89 15.89 0 002.91-3.63 1 1 0 00-.04-1z" })))));
}
exports["default"] = React.forwardRef(SvgEyeClose);
//# sourceMappingURL=EyeClose.js.map